
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiLocationO as ObiLocationOElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-location-o.js';
 
 
 

 
 export const ObiLocationO = createComponent({
   react: React,
   tagName: 'obi-location-o',
   elementClass: ObiLocationOElement,
   events: {
     
   }
  });
 
 